import { Controller } from "@hotwired/stimulus"

// Searchable replacement for a <select>: a text input filters a dropdown of
// options; picking one stores its value in a hidden field.
export default class extends Controller {
  static targets = ["input", "hidden", "menu", "option", "empty"]

  connect() {
    this.activeIndex = -1
  }

  open() {
    this.filter()
    this.menuTarget.classList.add("show")
  }

  close() {
    this.menuTarget.classList.remove("show")
    this.setActive(-1)
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  filter() {
    // Typing invalidates any previous pick so a stale id can't be submitted
    if (this.inputTarget.value !== this.selectedLabel) this.hiddenTarget.value = ""

    const query = this.inputTarget.value.trim().toLowerCase()
    let matches = 0

    this.optionTargets.forEach((option) => {
      const visible = option.textContent.toLowerCase().includes(query)
      option.hidden = !visible
      if (visible) matches++
    })

    this.emptyTarget.hidden = matches > 0
    this.menuTarget.classList.add("show")
    this.setActive(-1)
  }

  select(event) {
    const option = event.currentTarget
    this.hiddenTarget.value = option.dataset.value
    this.selectedLabel = option.textContent.trim()
    this.inputTarget.value = this.selectedLabel
    this.close()
  }

  keydown(event) {
    const visible = this.optionTargets.filter((option) => !option.hidden)

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.open()
        this.setActive(Math.min(this.activeIndex + 1, visible.length - 1), visible)
        break
      case "ArrowUp":
        event.preventDefault()
        this.setActive(Math.max(this.activeIndex - 1, 0), visible)
        break
      case "Enter":
        // Enter picks the highlighted option instead of submitting the form
        if (this.menuTarget.classList.contains("show")) {
          event.preventDefault()
          if (this.activeIndex >= 0 && visible[this.activeIndex]) visible[this.activeIndex].click()
        }
        break
      case "Escape":
        this.close()
        break
    }
  }

  setActive(index, visible = this.optionTargets.filter((option) => !option.hidden)) {
    this.activeIndex = index
    visible.forEach((option, i) => option.classList.toggle("active", i === index))
    if (index >= 0 && visible[index]) visible[index].scrollIntoView({ block: "nearest" })
  }
}
